import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

function GD_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <GD_FAQ/>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <GD_FAQ/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


function GD_FAQ(){
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>What steps should a beginner take to start learning Graphic Designing?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Begin with basics of design principles, color theory, and typography. Practice on tools like Photoshop and Illustrator, build a portfolio, and study real-world designs for inspiration.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>What are the key skills required to become a successful Graphic Designer?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Skills required:
  <ul>
    <li>Creativity, typography, color theory, layout design, photo editing, branding knowledge</li>
    <li>Proficiency in tools like Adobe Photoshop, Illustrator, InDesign, Figma, and Canva</li>
  </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>How is Graphic Designing different from UI/UX Designing?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
         Graphic Designing focuses on visual aesthetics, while UI/UX Designing focuses on user experience and interface design for digital platforms like websites and apps.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion className='py-2' expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>What is the role of Graphic Designing in web development?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
       Graphic design enhances websites by providing banners, icons, layouts, and visuals that improve user experience and brand image. A well-designed site keeps users engaged and professional.

          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion className='py-2' expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>How important is creativity in Graphic Designing?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
         Creativity is the core of Graphic Designing. It helps designers deliver unique, engaging, and meaningful designs that stand out in a competitive market.
          </Typography>
        </AccordionDetails>
      </Accordion>



    </div>
  );
}
export default GD_FAQ_page
